module.exports = __webpack_public_path__ + "img/square-light-colored-transparent.e7a9c01.svg";